import { axios } from '../utilities';

const approveCoverByCustomer = (bookId) => axios.post(`api/books/${bookId}/approve-cover-by-customer`);

const submitBookDraftToEditorByWriter = (bookId) =>
  axios.put(`api/books/${bookId}/draft/submit-by-writer`);

const submitBookDraftToEditorByDevelopmentalEditor = (bookId) =>
  axios.put(`api/books/${bookId}/draft/submit-by-developmental-editor`);

const sendBookDraftToCustomerByEditor = (bookId) => axios.put(`api/books/${bookId}/draft/send-to-customer`);

const approveBookDraftByCustomer = (bookId) => axios.put(`api/books/${bookId}/draft/approve-by-customer`);

const sendBookDraftCustomerFeedback = (bookId) => axios.put(`api/books/${bookId}/draft/send-customer-feedback`);

const sendBookDraftEditorFeedback = (bookId) => axios.put(`api/books/${bookId}/draft/send-editor-feedback`);

const sendBookOutlineEditorFeedback = (bookId) => axios.put(`api/books/${bookId}/outline/send-editor-feedback`);

const sendBookOutlineCustomerFeedback = (bookId) => axios.put(`api/books/${bookId}/outline/send-customer-feedback`);

const sendBookOutlineWriterFeedback = (bookId) => axios.put(`api/books/${bookId}/outline/send-writer-feedback`);

const updateSpecificField = (bookId, field, value) =>
  axios.put(`api/books/${bookId}/update-specific-field`, { field, value });

const sendDraftToCustomerByWriter = (bookId) => axios.put(`api/books/${bookId}/draft/send-to-customer-by-writer`);

const sendPDFToMyEmail = (bookId) => axios.post('api/books/send-pdf-to-my-email', { bookId });

const generateBookCover = (
  bookId,
  book,
) => axios.put(
  `api/books/${bookId}/generate-cover`,
  { book },
  // TODO: set an appropriate timeout instead of no timeout when PDF generation will be moved to the separate server
  { timeout: 0 },
);

const saveUserIdWhoReadNotificationDraftWasEdited = (projectId) => (
  axios.put(`/api/books/${projectId}/save-userid-who-read-notification-draft-was-edited`)
);

const addCommentToBookSample = (bookId, commentId, comment, sampleDelta) => axios.post(
  `api/books/${bookId}/book-sample/comments/${commentId}`,
  { comment, sampleDelta },
);

const deleteCommentInBookSample = (
  bookId,
  commentId,
  sampleDelta,
) => axios.put(
  `api/books/${bookId}/book-sample/comments/${commentId}/delete`,
  { sampleDelta },
);

const resolveCommentInBookSample = (
  bookId,
  commentId,
  sampleDelta,
) => axios.put(
  `api/books/${bookId}/book-sample/comments/${commentId}/resolve`,
  { sampleDelta },
);

const updateCommentInBookSample = (
  bookId,
  commentId,
  commentText,
) => axios.put(
  `api/books/${bookId}/book-sample/comments/${commentId}/update`,
  { commentText },
);

const addReplyToCommentInBookSample = (
  bookId,
  commentId,
  replyId,
  reply,
) => axios.post(
  `api/books/${bookId}/book-sample/comments/${commentId}/replies/${replyId}`,
  { reply },
);

const updateReplyToCommentInBookSample = (
  bookId,
  commentId,
  replyId,
  replyText,
) => axios.put(
  `api/books/${bookId}/book-sample/comments/${commentId}/replies/${replyId}`,
  { replyText },
);

const deleteComments = (
  bookId,
  commentsIds,
  fieldDelta,
  fieldName,
) => axios.put(
  `/api/books/${bookId}/book/comments/delete`,
  { fieldDelta, commentsIds, fieldName },
);

const undoComments = (
  bookId,
  commentsIds,
  fieldDelta,
  fieldName,
) => axios.put(
  `/api/books/${bookId}/book/comments/undo-delete`,
  { fieldDelta, commentsIds, fieldName },
);

const sendPDFToPrinter = (bookId, extraCopies) => axios.put(`api/books/${bookId}/send-pdf-to-printer`, { extraCopies });

const getBookAndResourcesByProjectId = (projectId) => axios.get(`api/books/staff/${projectId}/book-and-resources`);

const getBookAndResourcesByCustomerId = (userId) => axios.get(`api/books/customerId/${userId}/book-and-resources`);

const completeInterviewStage = (bookId) => axios.put(`api/books/${bookId}/complete-interview`);

const approveFinalProofByCustomer = (userId) =>
  axios.put(`api/books/${userId}/final-proof/approve-by-customer`);

const approveFinalProofByEditor = (projectId, editorId) =>
  axios.put(`api/books/${projectId}/final-proof/approve-by-editor`, { editorId });

const approveOutlineByEditor = (bookId) => axios.put(`api/books/${bookId}/outline/approve-by-editor`);

const approveOutlineByCustomer = (bookId) => axios.put(`api/books/${bookId}/outline/approve-by-customer`);

const submitOutlineByWriter = (bookId) => axios.put(`api/books/${bookId}/outline/submit-by-writer`);

const editorSendDraftToDevelopmentalEditor = (bookId) =>
  axios.put(`api/books/${bookId}/draft/send-to-developmental-editor-by-editor`);

const editorSendDraftToProProofreader = (bookId) =>
  axios.put(`api/books/${bookId}/draft/send-to-pro-proofreader-by-editor`);

const uploadDocumentToGoogleDocx = (bookId, file) =>
  axios.put(`api/books/${bookId}/google-docs-upload`, { file }, { timeout: 60000 });

const updateCoverCopy = (bookData) => axios.put(`api/books/${bookData._id}/update-cover-copy`, bookData);
const updateCoverOptions = (bookId, bookData) => axios.put(`api/books/${bookId}/update-cover-options`, bookData);

const closeOnboardingFeedbackModal = (projectId) =>
  axios.put(`/api/books/${projectId}/close-onboarding-feedback-modal`);

const addCommentToField = (bookId, commentId, comment, fieldDelta, fieldName) => axios.post(
  `api/books/${bookId}/add-comment/comments/${commentId}`,
  { comment, fieldDelta, fieldName },
);

const deleteCommentByFieldName = (
  bookId,
  commentId,
  fieldDelta,
  fieldName,
) => axios.put(
  `api/books/${bookId}/delete-comment/comments/${commentId}/delete`,
  { fieldDelta, fieldName },
);

const resolveCommentByFieldName = (
  bookId,
  commentId,
  fieldDelta,
  fieldName,
) => axios.put(
  `api/books/${bookId}/resolve-comment/comments/${commentId}/resolve`,
  { fieldDelta, fieldName },
);

const updateCommentByFieldName = (
  bookId,
  commentId,
  commentText,
  fieldName,
) => axios.put(
  `api/books/${bookId}/update-comment/comments/${commentId}/update`,
  { commentText, fieldName },
);

const addReplyToCommentByFieldName = (
  bookId,
  commentId,
  replyId,
  reply,
  fieldName,
) => axios.post(
  `api/books/${bookId}/add-comment-reply/comments/${commentId}/replies/${replyId}`,
  { reply, fieldName },
);

const updateReplyToCommentByFieldName = (
  bookId,
  commentId,
  replyId,
  replyText,
  fieldName,
) => axios.put(
  `api/books/${bookId}/update-comment-reply/comments/${commentId}/replies/${replyId}`,
  { replyText, fieldName },
);

const saveBookSampleChanges = (bookId, bookSample) => (
  axios.put(`/api/books/${bookId}/book-sample/save-changes`, { bookSample })
);

const approveBookSampleByCustomer = (bookId, bookSample) => (
  axios.put(`api/books/${bookId}/book-sample/approve-by-customer`, { bookSample })
);

const saveStyleSamplesChanges = (bookId, styleSamples) => (
  axios.put(`/api/books/${bookId}/style-samples/save-changes`, { styleSamples })
);

const approveStyleSampleByCustomer = (bookId, selectedStyleSampleId) => (
  axios.put(`/api/books/${bookId}/style-samples/approve-by-customer`, { selectedStyleSampleId })
);

const approveSampleByWriter = (bookId) => axios.put(`api/books/${bookId}/sample/approve-by-writer`);

const approveSampleByEditor = (bookId) => axios.put(`api/books/${bookId}/sample/approve-by-editor`);

const submitSpecification = (bookId, answers, structure) => axios.put(
  `api/books/${bookId}/submit-specification`,
  { answers, structure },
);

const saveSpecification = (bookId, answers, structure) => axios.put(
  `api/books/${bookId}/save-specification`,
  { answers, structure },
);

const uploadCustomPDF = (bookId, pdfUrl) => axios.put(`api/books/${bookId}/upload-custom-pdf`, { pdfUrl });

const uploadCustomCover = (bookId, coverUrl) => axios.put(`api/books/${bookId}/upload-custom-cover`, { coverUrl });

const addCommentToPDF = (bookId, commentText, pageNumber) =>
  axios.put(`api/books/${bookId}/comment-book-pdf`, { commentText, pageNumber });

const resolvePdfComment = (bookId, commentId) => axios.put(`api/books/${bookId}/resolve-pdf-comment`, { commentId });

const deletePdfComment = (bookId, commentId) => axios.put(`api/books/${bookId}/delete-pdf-comment`, { commentId });

const addReplyToPdfComment = (bookId, commentId, replyText) =>
  axios.put(`api/books/${bookId}/add-reply-pdf-comment`, { commentId, replyText });

const editPdfComment = (bookId, commentId, commentText) =>
  axios.put(`api/books/${bookId}/edit-pdf-comment`, { commentId, commentText });

const approveDraftByContentTeam = (bookId) => axios.put(`api/books/${bookId}/draft/approve-by-content-team`);

const submitBookDraftToEditorByProProofreader = (bookId) =>
  axios.put(`api/books/${bookId}/draft/submit-by-pro-proofreader`);

const proofRequestReview = (bookId) => axios.post(`api/books/${bookId}/proof-request-review`);

export default {
  generateBookCover,
  approveCoverByCustomer,
  submitBookDraftToEditorByWriter,
  submitBookDraftToEditorByDevelopmentalEditor,
  sendBookDraftToCustomerByEditor,
  approveBookDraftByCustomer,
  sendBookDraftCustomerFeedback,
  sendBookDraftEditorFeedback,
  sendBookOutlineEditorFeedback,
  sendBookOutlineCustomerFeedback,
  sendBookOutlineWriterFeedback,
  updateSpecificField,
  sendDraftToCustomerByWriter,
  sendPDFToMyEmail,
  saveUserIdWhoReadNotificationDraftWasEdited,
  addCommentToBookSample,
  deleteCommentInBookSample,
  resolveCommentInBookSample,
  updateCommentInBookSample,
  addReplyToCommentInBookSample,
  updateReplyToCommentInBookSample,
  deleteComments,
  undoComments,
  sendPDFToPrinter,
  getBookAndResourcesByProjectId,
  getBookAndResourcesByCustomerId,
  completeInterviewStage,
  approveFinalProofByCustomer,
  approveFinalProofByEditor,
  approveOutlineByEditor,
  approveOutlineByCustomer,
  submitOutlineByWriter,
  editorSendDraftToDevelopmentalEditor,
  editorSendDraftToProProofreader,
  uploadDocumentToGoogleDocx,
  updateCoverCopy,
  updateCoverOptions,
  closeOnboardingFeedbackModal,
  addCommentToField,
  deleteCommentByFieldName,
  resolveCommentByFieldName,
  updateCommentByFieldName,
  addReplyToCommentByFieldName,
  updateReplyToCommentByFieldName,
  saveBookSampleChanges,
  approveBookSampleByCustomer,
  saveStyleSamplesChanges,
  approveStyleSampleByCustomer,
  approveSampleByWriter,
  approveSampleByEditor,
  submitSpecification,
  saveSpecification,
  uploadCustomPDF,
  uploadCustomCover,
  addCommentToPDF,
  resolvePdfComment,
  deletePdfComment,
  addReplyToPdfComment,
  editPdfComment,
  approveDraftByContentTeam,
  submitBookDraftToEditorByProProofreader,
  proofRequestReview,
};
